import { useI18n } from "@/lib/i18n";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const LANGS = [
  { code: "pt", label: "PT" },
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
];

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger className="h-9 w-[72px]" data-testid="lang-switcher">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LANGS.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-${l.code}`}>
            {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
